import THREE from 'three';
import RTT from './RTT';

const frameSize = { x:512, y:512 };

export default class Step03 {

    constructor () {

        this.loader = new THREE.TextureLoader();

        this.mousePosition = new THREE.Vector2();

        this.clock = new THREE.Clock();
        this.scene = new THREE.Scene();

        this.camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 10000 );
        this.camera.position.z = 1000;
        
        this.renderer = new THREE.WebGLRenderer({alpha:true});
        this.renderer.setSize( window.innerWidth, window.innerHeight );
        this.renderer.setClearColor( 0x000000, 0 );
        
        document.body.appendChild( this.renderer.domElement );

        this.rtt = new RTT(512, 512, this.mousePosition);
        // this.rtt.render( this.renderer, this.clock.getDelta());

        this.mesh = this.newMesh();
        this.scene.add( this.mesh );

        // let ambientLight = new THREE.AmbientLight( 0x888888 );
        let ambientLight = new THREE.AmbientLight( 0xcccccc );
        this.scene.add( ambientLight );

        this.light = new THREE.PointLight( 0x777777, 0.7, 2500 );
        this.scene.add( this.light );
        this.light.position.z = 1500;

        document.addEventListener( 'mousemove', this.onMouseMove.bind(this), false );
        window.addEventListener( 'resize', this.onWindowResize.bind(this), false );

        this.onWindowResize();
        this.onMouseMove( {clientX:window.innerWidth/2, clientY:window.innerHeight/2} );
        this.animate();
    }

    onMouseMove(event) {

        this.mousePosition.x = (( event.clientX + document.body.scrollLeft ) / window.innerWidth - .5 ) * 2;
        this.mousePosition.y = -(( event.clientY + document.body.scrollTop ) / window.innerHeight - .5 ) * 2;
        this.light.position.x = window.innerWidth/2 * this.mousePosition.x;
        this.light.position.y = window.innerHeight/2 * this.mousePosition.y;
        this.light.position.z = this.camera.position.z/2;

    }

    onWindowResize() {

        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize( window.innerWidth, window.innerHeight );

        let scaleWidth = window.innerWidth/frameSize.x;
        let scaleHeight = window.innerHeight/frameSize.y;

        if ( scaleWidth < scaleHeight )
            this.camera.position.z = frameSize.x / this.camera.aspect / (2 * Math.tan(this.camera.fov / 2 * (Math.PI / 180)));
        else
            this.camera.position.z = frameSize.y / (2 * Math.tan(this.camera.fov / 2 * (Math.PI / 180)));             
    }

    newMesh () {

        this.paperTexture = this.loader.load('img/colors-center-512-neon-2.png');

        let geometry = new THREE.PlaneBufferGeometry( frameSize.x, frameSize.y );
        let material = new THREE.MeshPhongMaterial( { 
            map: this.paperTexture,
            shininess: 5,
            specular: 0x222222,
            specularMap: this.rtt.texture.texture,
            normalMap: this.rtt.texture.texture,
            normalScale: new THREE.Vector2( 1, 1 ),
            side: THREE.DoubleSide
        });

        return new THREE.Mesh( geometry, material );
    }


    animate() {
        
        requestAnimationFrame( this.animate.bind(this) );
     
        this.rtt.render( this.renderer, this.clock.getDelta());

        this.renderer.render( this.scene, this.camera );
    }

};



// WEBPACK FOOTER //
// ./src/js/steps/03/Step03.js